"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SessionContext_1 = require("./context/SessionContext");
const api_1 = require("./api");
const layout_1 = __importDefault(require("./components/FromBuilder/layout"));
const layout_2 = __importDefault(require("./components/DocumentBuilder/layout"));
const LayoutSelector = ({ newTemplateGenerate }) => {
    const { session } = (0, SessionContext_1.useSession)();
    switch (session === null || session === void 0 ? void 0 : session.docType) {
        case api_1.DOC_TYPE.FORM:
            return (0, jsx_runtime_1.jsx)(layout_1.default, {});
        case api_1.DOC_TYPE.WORD:
        case api_1.DOC_TYPE.PPT:
        case api_1.DOC_TYPE.PDF:
            return (0, jsx_runtime_1.jsx)(layout_2.default, { newTemplateGenerate: newTemplateGenerate });
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: "Unsupported document type" });
    }
};
exports.LayoutSelector = LayoutSelector;
